import { jsx } from 'react/jsx-runtime';
import { createContext, useState, useEffect, useContext } from 'react';
import { useOverlays, OverlayIds } from './OverlaysProvider.js';
import { usePaymentContext } from './PaymentContextProvider.js';

const CreditCardContext = createContext({
    setCreditCardsList: () => { },
});
const useCreditCardContext = () => useContext(CreditCardContext);
const CreditCardContextProvider = ({ children, creditCardsList: initList, selectedCardIdentifier: initIdentifier, }) => {
    const { showOverlay } = useOverlays();
    const { setSelectedPayment, deleteSavedCard, checkoutState } = usePaymentContext();
    const { paymentMethods } = checkoutState || {};
    const CC = paymentMethods?.find((pm) => pm.paymentMethodShortName === 'K');
    const [creditCardsList, setCreditCardsList] = useState(initList);
    const [selectedCardIdentifier, setSelectedCardIdentifier] = useState();
    const [status, setStatus] = useState('idle');
    const [cardToDelete, setCardToDelete] = useState();
    useEffect(() => {
        setCreditCardsList(initList);
    }, [initList]);
    useEffect(() => {
        setSelectedCardIdentifier(initIdentifier);
    }, [initIdentifier]);
    const deleteHandler = () => {
        cardToDelete && deleteSavedCard(cardToDelete);
    };
    const deleteCreditCard = (creditCard) => (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (creditCard) {
            setCardToDelete(creditCard);
            showOverlay(OverlayIds.DELETE_CARD_NEW);
        }
    };
    const selectCreditCard = (creditCard) => () => {
        if (creditCard) {
            setStatus('loading');
            setStatus('idle');
            setSelectedPayment({
                paymentMethod: 'CREDIT_CARD',
                paymentMethodShortName: 'K',
                details: { ...(CC?.details ?? {}), cards: [creditCard] },
            });
        }
    };
    return (jsx(CreditCardContext.Provider, { value: {
            deleteCreditCard,
            selectCreditCard,
            deleteHandler,
            status,
            cardToDelete,
            creditCardsList,
            selectedCardIdentifier,
            setCreditCardsList,
        }, children: children }));
};

export { CreditCardContext, CreditCardContextProvider, CreditCardContextProvider as default, useCreditCardContext };
//# sourceMappingURL=CreditCardContextProvider.js.map
